export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST" as const;
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS" as const;
export const REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE" as const;
export const RESET_REGISTER_STATE = "RESET_REGISTER_STATE" as const;
